<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-credit-card"></i> Bancos
                <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-plus"></i>
                  Entrada
                </b-link>
            </div>
            <b-card-body>
                <b-row>
                  <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="0" label="" class="mb-0">
                      <b-input-group>
                        <b-form-input v-model="keywords" v-on:keyup.enter="search" placeholder="Digite..."></b-form-input>
                        <b-input-group-append>
                          <b-button @click="search" variant="primary">Buscar</b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                 <b-row>
                    <b-col lg="12">
                      <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" striped></c-table>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import cTable from '../../../components/base/Table.vue'
import domainService from '../../../services/Bank/bankService'
import listPage from '../../../mixins/listPage';
export default {
  components: {cTable},
  mixins: [listPage],
  data() {
    return {
      actionUri: 'platform/banks',
      fields: [
        {key: 'code', label: 'Codigo', sortable: false},
        {key: 'name', label: 'Nome', sortable: false},
        {key: 'ispb', label: 'ISPB', sortable: false},
        {key: 'actions', label: ''}
      ]
    }
  },
  methods: {
    fetchData(page) {
        const self = this
        self.showLoading()
        domainService.findAll(this.keywords, page).then((response) =>{
            self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
            self.hideLoading()
        }, () =>{
            self.hideLoading()
        })
    }
  }
}
</script>
